import { render, staticRenderFns } from "./DistanceModalAddLinkedArchives.vue?vue&type=template&id=59efcb90&scoped=true&"
import script from "./DistanceModalAddLinkedArchives.vue?vue&type=script&lang=js&"
export * from "./DistanceModalAddLinkedArchives.vue?vue&type=script&lang=js&"
import style0 from "./DistanceModalAddLinkedArchives.vue?vue&type=style&index=0&id=59efcb90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59efcb90",
  null
  
)

export default component.exports